import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const SushiShef = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/sushi' name='Сушi вiд шефа'/>
            <main className={s.main}>
                <Product name='Сирний рол класичний' price='140 грн.' weight='250г./8шт.' info1='рис, норі, філаделфія, сир тостовий'/>
                <Product name='Сирний рол з беконом' price='160 грн.' weight='280г./8шт.' info1='рис, норі, філаделфія, бекон, сир твердий, сир тостовий'/>
                <Product name='Цезар' price='150 грн.' weight='270г./8шт.' info1='рис, норі, листя салату, філаделфія, помідор, бедро смажене, пармезан, кунжут, соус "Цезар"'/>
                <Product name='4 сири' price='210 грн.' weight='285г./8шт.' info1='рис, норі, філаделфія, фета, сир тостовий, пармезан'/>
                <Product name='Томаго' price='180 грн.' weight='280г./8шт.' info1='рис, норі, філаделфія, омлет, сир тостовий'/>
                <Product name='Сирний екзотик' price='210 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, ківі, сир тостовий, унарі, горіх мелений'/>
                <Product name='Королівська філа' price='200 грн.' weight='280г./8шт.' info1='рис, норі, філаделфія, лосось, фета, груша'/>
            </main>
        </div>
    )
}

export default SushiShef;